import React from "react";

type SubTitleProps = {
  children: string;
  className?: string;
};

export function SubTitle({ children, className }: SubTitleProps) {
  const classes = [
    "SubTitle", // Keep BEM class for debugging
    "text-[13px]",
    "mt-[calc(var(--panelPadding)*2)]",
    "mb-[var(--panelPadding)]",
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <div className="SubTitle__text">{children}</div>
    </div>
  );
}
